import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { getEndpointBySistema } from './httpSistema'
import { Comentario, schemaComentario } from '../types'
import { z } from 'src/lib'

export const getComentarios = (codSistema: number, idOperacion: number): Promise<Comentario[]> => {
    const endpoint = `${getEndpointBySistema(codSistema)}/${idOperacion}/comentarios`

    const schema = z.array(schemaComentario)

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schema.safeParse(response)

            if (!parsed.success) {
                console.error(parsed.error.issues)

                return Promise.reject('Error de validación.')
            }

            return Promise.resolve(parsed.data)
        })
        .catch(error => {
            console.error(error)

            return Promise.reject('Error de red.')
        })
}
